<template>

  <div v-if="state.sectionShown">
    <div class="flex mb-[10px] lg:mb-[30px]">
      <p class="font-semibold uppercase text-[#2699C6] md:text-[32px] text-[16px]">faq</p>
    </div>
    <div>
      <p class="mb-6 text-big-body">
        <span class="font-extrabold text-gray-900 md:text-[56px] text-[28px]">Co vás nejvíce zajímá?</span>
      </p>
      <div>
        <Faq v-for="faq in state.faqs" :key="faq._uid" :faq="faq" />
      </div>
    </div>
  </div>

</template>

<script setup>
import Faq from './Faq.vue';

import { onMounted, reactive } from "vue";
import { useStoryblokBridge } from "@storyblok/vue";
import useStoryBlokData from '../../composables/useStoryBlokData';

const { getStoryBlokData } = useStoryBlokData();

const state = reactive({
  faqs: null,
  sectionShown: false,
});

onMounted(async () => {
  const { data } = await getStoryBlokData();

  const node = data.story.content.body.find(bodyElements => bodyElements.id === 'faqs');

  state.faqs = node.faq;
  state.sectionShown = node.shown;

  useStoryblokBridge(data.story.id, (story) => {
    const node = story.content.body.find(bodyElements => bodyElements.id === 'faqs');

    state.faqs = node.faq;
    state.sectionShown = node.shown;
  });
});

</script>

<style>

</style>
